<template>
  <div>
    <div v-if="dropownLoader">
      <Loader />
    </div>

    <div v-else class="tw-mx-2  tw-mt-4">
      <div class="card tw-border-0 tw-p-4  tw-mb-4 tw-bg-white tw-rounded-lg tw-shadow-sm">
          <div class="tw-flex tw-flex-col lg:tw-flex-row tw-justify-between tw-items-start lg:tw-items-center tw-gap-4">
        <div id="werehouseDateRange" class="tw-flex tw-flex-col sm:tw-flex-row tw-gap-4 tw-w-full lg:tw-w-auto tw-min-w-0">
          <div class="tw-w-full sm:tw-w-48 tw-min-w-0">
            <div class="tw-text-[#050A13] tw-text-xs sm:tw-text-sm md:tw-text-base tw-mb-2 sm:tw-mb-3 tw-mx-1">
              Date
            </div>
            <date-range-picker
              v-model="dateRange"
              :show-dropdowns="true"
              opens="right"
              :autoApply="true"
              :locale-data="{ format: 'dd mmm yyyy' }"
              :max-date="maxDate"
              @update="formateDate"
              class="tw-w-full tw-min-w-0"
            >
            </date-range-picker>
          </div>
          <div class="customMultiselectCommon tw-w-full sm:tw-w-48">
            <div class="tw-text-[#050A13] tw-text-[12px] sm:tw-text-[14px] tw-mb-2 sm:tw-mb-3 tw-mx-1">
              Channel
            </div>
            <multiselect
              v-model="selectedChannel"
              :options="channelList"
              :multiple="false"
              :searchable="false"
              placeholder="Select Channel"
              label="label"
              track-by="key"
              class="tw-w-full"
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
              @select="dataAPIs"

            >
            </multiselect>
          </div>
          <div class="customMultiselectCommon tw-w-full sm:tw-w-48">
            <div class="tw-text-[#050A13] tw-text-[12px] sm:tw-text-[14px] tw-mb-2 sm:tw-mb-3 tw-mx-1">
              Warehouse
            </div> 
            <multiselect
              v-model="selectedWarehouse"
              :options="warehouseList"
              :multiple="false"
              :searchable="false"
              placeholder="Select Warehouse"
              label="label"
              track-by="key"
               class="tw-w-full"
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
              @select="dataAPIs"

            >
            </multiselect>
          </div>
          <div class="customMultiselectCommon tw-w-full sm:tw-w-48">
            <div class="tw-text-[#050A13] tw-text-[12px] sm:tw-text-[14px] tw-mb-2 sm:tw-mb-3 tw-mx-1">
              Category
            </div>
            <multiselect
              v-model="selectedCategory"
              :options="categoryList"
              :multiple="false"
              :searchable="false"
              placeholder="Select Warehouse"
              label="label"
              track-by="key"
               class="tw-w-full"
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
              @select="dataAPIs"

            >
            </multiselect>
          </div>
          <div class="customMultiselectCommon tw-w-full sm:tw-w-48">
            <div class="tw-text-[#050A13] tw-text-[12px] sm:tw-text-[14px] tw-mb-2 sm:tw-mb-3 tw-mx-1">
              Reports Types
            </div>
            <multiselect
              v-model="selectedReportType"
              :options="reportTypeList"
              :multiple="false"
              :searchable="true"
              placeholder="Select Report Type"
              label="label"
              track-by="key"
               class="tw-w-full"
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
              @select="formateDate"

            >
            </multiselect>
          </div>
        </div>
      </div>
      </div>
      
      <div class="card tw-border-0 tw-mb-4 tw-z-[10] tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-5 tw-gap-4" v-if="summaryMetricData"> 
          <div v-for="(card,idx) of summaryMetricData" :key="idx"> 
              <div class="tw-border-[1px] tw-border-[#D4D4D4] tw-rounded-[5px] tw-p-3 sm:tw-p-4 tw-bg-white tw-shadow-sm">
                  <div class="tw-flex tw-justify-start tw-mb-3 sm:tw-mb-4 tw-items-center tw-flex-wrap">
                    <img :src="'Icons_SVG/'+Object.entries(card)[0][0].toLocaleLowerCase()+'.svg'" class="tw-border-[#D4D4D4] tw-p-2 tw-rounded-[5px] tw-border tw-w-8 tw-h-8 sm:tw-w-10 sm:tw-h-10"/>
                    <div class="tw-border-[#5E5E5E1A] tw-bg-[#5E5E5E1A] tw-text-[10px] sm:tw-text-[12px] tw-py-[6px] sm:tw-py-[8px] tw-px-[8px] sm:tw-px-[12px] tw-ml-2 sm:tw-ml-4 tw-rounded-[5px] tw-font-semibold tw-align-middle tw-whitespace-nowrap">{{formatNumber(Object.entries(card)[2][1])}} Orders</div>
                  </div>
                  <div class="">
                    <div class="tw-border-b-[1px] tw-border-[#D4D4D4] tw-my-2 sm:tw-my-3 tw-pb-2">
                      <div class="tw-text-[12px] sm:tw-text-[14px] tw-text-[#5E5E5E] tw-font-semibold tw-capitalize tw-truncate">{{Object.entries(card)[0][0].replaceAll("_"," ")}}</div>
                      <div class="tw-mt-1 sm:tw-mt-2 tw-text-[18px] sm:tw-text-[24px] tw-text-[#000] tw-font-semibold tw-truncate">₹ {{formatNumber(Object.entries(card)[0][1])}}</div>
                    </div>
                    <div class="">
                        <div class="tw-text-[12px] sm:tw-text-[14px] tw-text-[#5E5E5E] tw-font-semibold tw-capitalize tw-truncate">{{Object.entries(card)[1][0].replaceAll("_"," ")}}</div>
                        <div class="tw-mt-1 sm:tw-mt-2 tw-text-[18px] sm:tw-text-[24px] tw-text-[#000] tw-font-semibold tw-truncate">{{formatNumber(Object.entries(card)[1][1])}}</div>
                    </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="card tw-border-0 tw-mb-0 md:tw-mb-4 row tw-z-[10]" v-else>
          <noData :loaderVariable="metricLoader"/>
      </div>
      <div  class="card tw-border-0 summaryContainer tw-m-0 tw-mb-4  tw-z-[10]">
          <div>
              <div class="tw-flex  sm:tw-flex-row tw-justify-between tw-items-start sm:tw-items-center tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4] tw-gap-4">
                  <div class="tw-text-[14px] sm:tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2">Orders Breakup</div>
                  <div class="tw-flex sm:tw-flex-row tw-gap-2">
                    <button
                      class="ui button exportButton tw-ml-0 sm:tw-ml-1 tw-text-sm sm:tw-text-base tw-px-3 sm:tw-px-6 tw-py-2" @click="exportOrdersBreakupData(activeTab)">
                      <svg v-if="isTabWiseExporting " aria-hidden="true" role="status" class="tw-inline tw-w-4 tw-h-4 tw-mr-1 tw-text-white tw-animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                      </svg>
                      {{isTabWiseExporting?'Exporting...':'Export'}}
                    </button>
                    <button
                      class="ui button exportButton tw-ml-0 sm:tw-ml-1 tw-text-sm sm:tw-text-base tw-px-3 sm:tw-px-6 tw-py-2" @click="exportOrdersBreakupData('All')">
                      <svg v-if="isAllDownload" aria-hidden="true" role="status" class="tw-inline tw-w-4 tw-h-4 tw-mr-1 tw-text-white tw-animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                      </svg>
                      {{isAllDownload?'Exporting All...':'Export All'}}
                    </button>
                  </div>
              </div>
              <div></div>
          </div>
          <div class="d-flex tw-overflow-x-auto tw-overflow-y-hidden tw-whitespace-nowrap sovReviewedTab">
              <div class="mx-3 font-bold tab-label tw-cursor-pointer tw-text-xs sm:tw-text-base tw-whitespace-nowrap"  v-for="d in orderBreakdownTablist"
                  :key="d.key" @click="handleOrdersTableTab(d.key)"  :class="{ active: d.key === activeTab }">
                  {{d.value}}
              </div>
          </div>
          <div class="borderBetweenTab" ></div>
        <div v-if="Object.keys(viewOrderBreakdownTabelData).length" style="overflow:auto;">
          <table id="summaryDataTable" class="tw-w-full tw-mt-3 tw-min-h-[100px]">
            <thead>
              <tr>
                <th v-for="(item, index) in viewOrderBreakdownTabelData.headers" :key="index">
                  <span>{{ item.value }}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in viewOrderBreakdownTabelData.data" :key="idx"  v-if="item[activeTab]!='Total' ">
                <td v-for="(head, index) in viewOrderBreakdownTabelData.headers" :key="index">
                  {{ formatNumber(item[head.key]) }}
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr v-for="(item, index) in viewOrderBreakdownTabelData.data" :key="index" v-if="String(item[activeTab]).includes('Total')" class="!tw-bg-[#7f8f901a] tw-text-![#5E5E5E]">
                <td v-for="(head, index) in viewOrderBreakdownTabelData.headers" :key="index" class="tw-text-[#5E5E5E]">
                  <span> {{ formatNumber(item[head.key]) }} </span>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div v-else class="tw-min-h-[400px]">
          <noData :loaderVariable="summaryTableLoader"/>
        </div>
      </div>
      <div class="summaryContainer tw-m-0 tw-z-[10] tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-4"> 
        <div class="lg:tw-col-span-8 card tw-mb-0 md:tw-mb-4 tw-border-0   tw-bg-white tw-rounded-lg tw-shadow-sm tw-p-4">
          <div class="tw-flex tw-justify-between tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4]">
              <span class="tw-text-[14px] sm:tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2">Net Sales</span>
          </div>
          <div v-if="proccedNetSalesGraphData" class="tw-w-full">
            <dynamicChart :data="proccedNetSalesGraphData" :isLegend="true" :height="400"/>
          </div>
          <div class="" v-else>
              <noData :loaderVariable="metricLoader"/>
          </div>
        </div>
        <div class="lg:tw-col-span-4 card tw-border-0 tw-mb-4 md:tw-mb-4 tw-bg-white tw-rounded-lg tw-shadow-sm tw-p-4">
            <div class="tw-flex tw-justify-between tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4]">
              <span class="tw-text-[14px] sm:tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2">Net Sales Overview</span>
            </div>
            <div v-if="proccedNetSalesPieChartData.length" class="tw-w-full tw-overflow-x-auto"> 
              <pieChart :data="proccedNetSalesPieChartData"/>
            </div>
            <div class="" v-else>
              <noData :loaderVariable="metricLoader"/>
          </div>
        </div>
      </div>

      <!-- net sales breakup graph section  -->
      <div class="summaryContainer tw-m-0  tw-z-[12] tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-4"> 
        <div class="lg:tw-col-span-6 card tw-border-0 tw-mb-0 md:tw-mb-4 tw-bg-white tw-rounded-lg tw-shadow-sm tw-p-4">
          <div class="tw-flex tw-justify-between tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4]">
              <span class="tw-text-[14px] sm:tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2">Net Sales Breakup by Channel</span>
          </div>
          <div v-if="proccedNetSalesBreakupStackChartData" class="tw-w-full tw-overflow-x-auto">
            <stackChart :rawData="proccedNetSalesBreakupStackChartData" :height="450"/>
          </div>
          <div class="" v-else>
              <noData :loaderVariable="netSalesBreakupLoader"/>
          </div>
        </div>
        <div class="lg:tw-col-span-3 card tw-border-0 tw-mb-0 md:tw-mb-4 tw-bg-white tw-rounded-lg tw-shadow-sm tw-p-4">
            <div class="tw-flex tw-justify-between tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4]">
              <span class="tw-text-[14px] sm:tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2">Net Sales Overview by Channel</span>
            </div>
            <div v-if="proccedNetSalesBreakupSemiPieChartData.length" class="tw-w-full tw-overflow-x-auto"> 
              <pieChart :data="proccedNetSalesBreakupSemiPieChartData"/>
            </div>
            <div class="" v-else>
              <noData :loaderVariable="netSalesBreakupLoader"/>
            </div>
        </div>
        <div class="lg:tw-col-span-3 card tw-border-0 tw-mb-4 tw-bg-white tw-rounded-lg tw-shadow-sm tw-p-4">
            <div class="tw-flex tw-justify-between tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4]">
              <span class="tw-text-[14px] sm:tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2">Net Sales Overview by Category</span>
            </div>
            <div v-if="proccedNetSalesBreakupPieChartData.length" class="tw-w-full tw-overflow-x-auto">
              <pieChart :data="proccedNetSalesBreakupPieChartData"/>
            </div>
            <div class="" v-else>
              <noData :loaderVariable="netSalesBreakupLoader"/>
          </div>
        </div>
      </div>

      <!-- RTV graph section  -->

      <div class="summaryContainer tw-m-0  tw-z-[12] tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-4"> 
        <div class="lg:tw-col-span-6 card tw-border-0 tw-mb-0 md:tw-mb-4 tw-bg-white tw-rounded-lg tw-shadow-sm tw-p-4">
          <div class="tw-flex tw-justify-between tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4]">
              <span class="tw-text-[14px] sm:tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2">Customer Returns (RTV) Breakup by Channel</span>
          </div>
          <div v-if="proccedRTVSalesBreakupStackChartData" class="tw-w-full tw-overflow-x-auto"> 
            <stackChart :rawData="proccedRTVSalesBreakupStackChartData" :height="450"/>
          </div>
          <div class="" v-else>
              <noData :loaderVariable="rtvLoader"/>
            </div>
        </div>
        <div class="lg:tw-col-span-3 card tw-border-0 tw-mb-0 md:tw-mb-4 tw-bg-white tw-rounded-lg tw-shadow-sm tw-p-4">
            <div class="tw-flex tw-justify-between tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4]">
              <span class="tw-text-[14px] sm:tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2">Customer Returns (RTV) Overview by Channel</span>
            </div>
            <div v-if="proccedRTVSalesBreakupSemiPieChartData.length" class="tw-w-full tw-overflow-x-auto"> 
              <pieChart :data="proccedRTVSalesBreakupSemiPieChartData"/>
            </div>
            <div class="" v-else>
              <noData :loaderVariable="rtvLoader"/>
            </div>
        </div>
        <div class="lg:tw-col-span-3 card tw-border-0 tw-mb-4 tw-bg-white tw-rounded-lg tw-shadow-sm tw-p-4">
            <div class="tw-flex tw-justify-between tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4]">
              <span class="tw-text-[14px] sm:tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2">Customer Returns (RTV) Overview by Category</span>
            </div>
            <div v-if="proccedRTVSalesBreakupPieChartData.length" class="tw-w-full tw-overflow-x-auto"> 
              <pieChart :data="proccedRTVSalesBreakupPieChartData"/>
            </div>
            <div class="" v-else>
              <noData :loaderVariable="rtvLoader"/>
            </div>
        </div>
      </div>
      <!-- RTO Breakup graph -->
      <div class="summaryContainer tw-m-0  tw-z-[12] tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-4"> 
        <div class="lg:tw-col-span-6 card tw-border-0 tw-mb-0 md:tw-mb-4 tw-bg-white tw-rounded-lg tw-shadow-sm tw-p-4">
          <div class="tw-flex tw-justify-between tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4]">
              <span class="tw-text-[14px] sm:tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2">Courier Returns (RTO) Breakup by Channel</span>
          </div>
          <div v-if="proccedRTOBreakupStackChartData" class="tw-w-full tw-overflow-x-auto"> 
            <stackChart :rawData="proccedRTOBreakupStackChartData" :height="450"/>
          </div>
          <div class="" v-else>
              <noData :loaderVariable="rtoLoader"/>
            </div>
        </div>
        <div class="lg:tw-col-span-3 card tw-border-0 tw-mb-0 md:tw-mb-4 tw-bg-white tw-rounded-lg tw-shadow-sm tw-p-4">
            <div class="tw-flex tw-justify-between tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4]">
              <span class="tw-text-[14px] sm:tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2">Courier Returns (RTO) Overview by Channel</span>
            </div>
            <div v-if="proccesRTOBreakupSemiPieChartData.length" class="tw-w-full tw-overflow-x-auto"> 
              <pieChart :data="proccesRTOBreakupSemiPieChartData"/>
            </div>
            <div class="" v-else>
              <noData :loaderVariable="rtoLoader"/>
            </div>

        </div>
        <div class="lg:tw-col-span-3 card tw-border-0 tw-mb-4 tw-bg-white tw-rounded-lg tw-shadow-sm tw-p-4">
            <div class="tw-flex tw-justify-between tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4]">
              <span class="tw-text-[14px] sm:tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2">Courier Returns (RTO) Overview by Category</span>
            </div>
            <div v-if="proccesRTOBreakupPieChartData.length" class="tw-w-full tw-overflow-x-auto"> 
              <pieChart :data="proccesRTOBreakupPieChartData"/>
            </div>
            <div class="" v-else>
              <noData :loaderVariable="rtoLoader"/>
            </div>
        </div>
      </div>
       <!-- COD Section -->
      <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-4">
        <div class="card tw-border-0 tw-mb-0 md:tw-mb-4 tw-z-[10] tw-bg-white tw-rounded-lg tw-shadow-sm tw-p-4">
          <div class="tw-flex tw-justify-between tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4]">
              <span class="tw-text-[12px] sm:tw-text-[14px] lg:tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2 tw-leading-tight">COD/Prepaid Orders Overview by Channel</span>
          </div>
          <div v-if="proccedPrepaidCODPieByChannelData" class="tw-w-full tw-overflow-x-auto">
            <pieChart :data="proccedPrepaidCODPieByChannelData"/>
          </div>
        </div>
        <div class="card tw-border-0 tw-mb-0 md:tw-mb-4  tw-z-[10] tw-bg-white tw-rounded-lg tw-shadow-sm tw-p-4">
          <div class="tw-flex tw-justify-between tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4]">
              <span class="tw-text-[12px] sm:tw-text-[14px] lg:tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2 tw-leading-tight">COD/Prepaid Orders Overview by Category</span>
          </div>
          <div v-if="proccedPrepaidCODPieByCategoryData" class="tw-w-full tw-overflow-x-auto">
            <pieChart :data="proccedPrepaidCODPieByCategoryData"/>
          </div>
        </div>
        <div class="card tw-border-0 tw-mb-0 md:tw-mb-4  tw-z-[10] tw-bg-white tw-rounded-lg tw-shadow-sm tw-p-4">
          <div class="tw-flex tw-justify-between tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4]">
              <span class="tw-text-[12px] sm:tw-text-[14px] lg:tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2 tw-leading-tight">Cancelled COD/Preapid Orders Overview by Channel</span>
          </div>
          <div v-if="proccedCancelledPrepaidCODPieByChannelData" class="tw-w-full tw-overflow-x-auto">
            <pieChart :data="proccedCancelledPrepaidCODPieByChannelData"/>
          </div>
        </div>
        <div class="card tw-border-0 tw-mb-4  tw-z-[10] tw-bg-white tw-rounded-lg tw-shadow-sm tw-p-4">
          <div class="tw-flex tw-justify-between tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4]">
              <span class="tw-text-[12px] sm:tw-text-[14px] lg:tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2 tw-leading-tight">Cancelled COD/Preapid Orders Overview by Category</span>
          </div>
          <div v-if="proccedCategoryPrepaidCODPieByCategoryData" class="tw-w-full tw-overflow-x-auto">
            <pieChart :data="proccedCategoryPrepaidCODPieByCategoryData"/>
          </div>
        </div>
      </div>
      <div class="card tw-border-0 tw-mb-0 md:tw-mb-4 tw-z-[10] tw-bg-white tw-rounded-lg tw-shadow-sm tw-p-4" v-if="Object.keys(viewDemographicData).length"> 
        <div class="tw-flex tw-justify-between tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4]">
            <span class="tw-text-[14px] sm:tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2">Demographics</span>
        </div>
        <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-4">
          <div class="lg:tw-border-r-[1.5px] lg:tw-border-[#D4D4D4] tw-pr-0 lg:tw-pr-4">
             <div class="customMultiselectCommon tw-flex tw-justify-end tw-pr-2 tw-mb-4">
                <multiselect
                  v-model="selectedIndiaMapData"
                  :options="demographicsDropdownData"
                  :multiple="false"
                  :searchable="false"
                  placeholder="Select "
                  label="label"
                  track-by="key"
                  class="tw-w-full sm:tw-w-[215px] tw-capitalize"
                  :showLabels="false"
                  :close-on-select="true"
                  :allow-empty="false"
                  @select="processIndiaMapData"
                >
            </multiselect>
          </div>
          <div v-if="proccedIndiaMapData.length" class="tw-w-full tw-overflow-x-auto">
            <indiaMap :data="proccedIndiaMapData" :isLegend="true" :height="600" suffix=""/>
          </div>
          <div v-else>
            <noData :loaderVariable="demographicLoader"/>
          </div>
          </div>
          <div v-if="Object.keys(viewDemographicData).length" class="summaryContainer tw-w-full">
            <table id="demographicsDataTable" class="tw-w-full  tw-text-sm sm:tw-text-base">
              <thead>
                <tr class="tw-bg-gray-50">
                  <th v-for="(item, index) in viewDemographicData.headers" :key="index" >
                    <span class="">{{ item.value }}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in viewDemographicData.data" :key="idx" v-if="item.state!='TOTAL'" >
                  <td v-for="(head, index) in viewDemographicData.headers" :key="index" >
                    <span class="">{{ formatNumber(item[head.key]) }}</span>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr v-for="(item, index) in viewDemographicData.data" :key="index" v-if="String(item.state).includes('TOTAL')" class="tw-bg-[#7f8f901a] tw-text-![#5E5E5E] tw-font-semibold">
                  <td v-for="(head, index) in viewDemographicData.headers" :key="index" class="tw-text-[#5E5E5E] tw-px-3 tw-py-2">
                    <span class=""> {{ formatNumber(item[head.key]) }} </span>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div v-else>
            <noData :loaderVariable="demographicLoader"/>
          </div>
        </div>
      </div>
     
      
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import Multiselect from "vue-multiselect";
import Loader from "../Components/Loader.vue";
import dynamicChart from "../commonCharts/Chart/dynamicChart.vue";
import pieChart from "../commonCharts/Chart/commonPieChart.vue";
import StateMapper from '../commonCharts/IndiaState.json'
import indiaMap from "../commonCharts/IndiaMap.vue";
import stackChart from "../commonCharts/StackChart.vue";
import noData from "../Components/noData.vue";
export default {
  name: "summary",
  components: { Datepicker, Multiselect, Loader,dynamicChart,pieChart,indiaMap,stackChart,noData },
  data: function () {
    return {
      dropownLoader: false,
      step: 1,
      skuInput: "",
      suggestions: [],
      selectedWarehouse: "",
      warehouseList: [],
      categoryList:[],
      selectedCategory:"",
      reportTypeList:[],
      selectedReportType:'',
      selectedChannel:"",
      selecetdQuantity: "",
      selectedTowards: "",
      summaryData: [],
      dateRange: {
        startDate: moment().subtract(15,'days').format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      // Loader Section start
      metricLoader: false,
      isTabWiseExporting: false,
      isAllDownload: false,
      netSalesLoader: false,
      netSalesBreakupLoader: false,
      rtoLoader: false,
      rtvLoader: false,
      demographicLoader: false,
      cancelledCODPrepaidLoader: false,
      // loader Section end
      maxDate: new Date(),
      activeTab: 0,
      summaryTableLoader:false,
      summaryMetricData:'',
      uploadFileLoader:false,
      channelList:[{
        key:'All Channels',
        label:'All Channels'
      }],
      selectedChannel:{
        key:'All Categories',
        label:'All Category'
      },
      activeTab:'model',
      orderBreakdownTablist: [
        { key: "model", value: "Model Wise" },
        { key: "sku", value: "SKU Wise" },
        { key: "size_", value: "Size Wise" },
        { key: "status", value: "Status" },
        { key: "channel", value: "Channel" },
        { key: "Category", value: "Category" },
        { key: "facilityCode", value: "Warehouse" }
      ],
      viewOrderBreakdownTabelData:'',
      viewDemographicData : '',
      proccedNetSalesGraphData:{},
      proccedNetSalesPieChartData:[],
      viewNetSalesData:'',
      viewNetSalesBreakupData:'',
      proccedNetSalesBreakupStackChartData:'',
      proccedNetSalesBreakupSemiPieChartData:'',
      proccedNetSalesBreakupPieChartData:'',
      viewRTOBreakupData:'',
      proccedRTOBreakupStackChartData:'',
      proccesRTOBreakupPieChartData:'',
      proccesRTOBreakupSemiPieChartData:'',
      viewRTVSalesBreakupData:'',
      proccedRTVSalesBreakupStackChartData:'',
      proccedRTVSalesBreakupSemiPieChartData:'',
      proccedRTVSalesBreakupPieChartData:'',
      proccedIndiaMapData:[],
      indiaStateMapper: StateMapper,
      demographicsDropdownData:'',
      selectedIndiaMapData:'',
      viewCODPrepaidData:'',
      proccedPrepaidCODPieByChannelData:'',
      proccedPrepaidCODPieByCategoryData:'',
      viewCancelledCODPrepaidData:'',
      proccedCancelledPrepaidCODPieByChannelData:'',
      proccedCategoryPrepaidCODPieByCategoryData:''
    };
  },
  mounted() {
    // this.getDropdownData();
    this.getDropdownData();
    this.$store.dispatch("DemoStore/setTimeStamp", '');
    this.$store.dispatch("DemoStore/setUpdatedStatus", "");

  },

  methods: {

    dataAPIs(){
      if ($.fn.DataTable.isDataTable('#summaryDataTable')) {
          $('#summaryDataTable').DataTable().destroy();
      }
      this.getMetricData();
      this.getOrderBreakDownTableData();
      this.getNetSalesData();
      this.getNetSalesBreakUPData();
      this.getRTOBreakupData();
      this.getRTVBreakupData();
      this.getDemographicData();
      this.getCODPrepaidData();
      this.getCancelledCODPrepaidData();
    },

    formateDate(){
      this.dateRange.startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
      this.dateRange.endDate =  moment(this.dateRange.endDate).format("YYYY-MM-DD");
      this.dataAPIs();
    },

    formatNumber(num) {
        if (isNaN(num)) return num
        let num1 = Number(num).toFixed(2);
        let num2 = Number(num1).toLocaleString();
        return num2
    },

    handleOrdersTableTab(tab){
      this.activeTab = ''
      this.activeTab = tab
      this.getOrderBreakDownTableData();
    },

    getDropdownData() {
      this.dropownLoader = true;  
      const url = "/api/unicommerce/filters/";
      this.$http
        .get(url)
        .then((response) => {
          this.warehouseList = response.data.data.Warehouse;
          this.selectedWarehouse = this.warehouseList[0];
          this.categoryList = response.data.data.Category;
          this.selectedCategory = this.categoryList[0];
          this.reportTypeList = response.data.data.ReportType;
          this.selectedReportType = this.reportTypeList[0];
          this.channelList = response.data.data.Channel;
          this.selectedChannel= this.channelList[0]
          this.dropownLoader = false;
          this.dataAPIs();
        })
        .catch((error) => {
          this.dropownLoader = false;
          console.error("Error fetching warehouse data:", error);
        });
    },

  
    getNetSalesData(){
      this.viewNetSalesData = ''
      this.proccedNetSalesGraphData = ''
      this.proccedNetSalesPieChartData = ''
      this.netSalesLoader = true;
      let url = "/api/unicommerce/net-sales/?start_date="+this.dateRange.startDate
      url+= "&end_date="+this.dateRange.endDate
      url += "&channel="+JSON.stringify([this.selectedChannel?.key])
      url += "&category="+JSON.stringify([this.selectedCategory?.key])
      url += "&warehouse="+JSON.stringify([this.selectedWarehouse?.key])
      
      this.$http
        .get(url)
        .then((response) => {
          this.netSalesLoader = false;
          this.viewNetSalesData = response.data.data.data;
          this.processNetSalesGraph();
        })
        .catch((error) => {
          this.netSalesLoader = false;
          console.error("Error fetching table data:", error);
        });
    },

    getNetSalesBreakUPData(){
      this.viewNetSalesData = ''
      this.netSalesBreakupLoader = true;
      let url = "/api/unicommerce/net-sales/breakup?start_date="+this.dateRange.startDate
      url+= "&end_date="+this.dateRange.endDate
      url += "&channel="+JSON.stringify([this.selectedChannel?.key])
      url += "&category="+JSON.stringify([this.selectedCategory?.key])
      url += "&warehouse="+JSON.stringify([this.selectedWarehouse?.key])
      this.$http
        .get(url)
        .then((response) => {
          this.viewNetSalesBreakupData = response.data.data.data;
          this.proccedNetSalesBreakupStackChartData = this.processStackChart(this.viewNetSalesBreakupData.monthly_data,'Net Sales Breakup by Channel');
          this.proccedNetSalesBreakupSemiPieChartData = this.processPieChart(this.viewNetSalesBreakupData.net_sales_pie_chart_data,'Net Sales by Channel',50);
          this.proccedNetSalesBreakupPieChartData = this.processPieChart(this.viewNetSalesBreakupData.category_pie_chart_data,'Net Sales by Category',0);
          this.netSalesBreakupLoader = false;
        })
        .catch((error) => {
          this.netSalesBreakupLoader = false;
          console.error("Error fetching table data:", error);
        });
    },


    getRTVBreakupData(){
      this.viewNetSalesData = ''
      this.proccedRTVSalesBreakupStackChartData =''
      this.proccedRTVSalesBreakupPieChartData = ''
      this.proccedRTVSalesBreakupSemiPieChartData = ''
      this.rtvLoader = true;
      let url = "/api/unicommerce/rtv/breakup?start_date="+this.dateRange.startDate
      url+= "&end_date="+this.dateRange.endDate
      url += "&channel="+JSON.stringify([this.selectedChannel?.key])
      url += "&category="+JSON.stringify([this.selectedCategory?.key])
      url += "&warehouse="+JSON.stringify([this.selectedWarehouse?.key])
      this.$http
        .get(url)
        .then((response) => {
          this.viewRTVSalesBreakupData = response.data.data.data;
          this.proccedRTVSalesBreakupStackChartData = this.processStackChart(this.viewRTVSalesBreakupData.monthly_data,'Courier Returns (RTO) Breakup by Channel');
          this.proccedRTVSalesBreakupSemiPieChartData = this.processPieChart(this.viewRTVSalesBreakupData.rtv_sales_pie_chart_data,'RTV Sales by Channel',50);
          this.proccedRTVSalesBreakupPieChartData = this.processPieChart(this.viewRTVSalesBreakupData.category_pie_chart_data,'RTV Sales by category',0)
          this.rtvLoader = false;
        })
        .catch((error) => {
          this.rtvLoader = false;
          console.error("Error fetching table data:", error);
        });
    },

    getRTOBreakupData(){
      this.viewNetSalesData = ''
      this.rtoLoader = true;
      let url = "/api/unicommerce/rto/breakup?start_date="+this.dateRange.startDate
      url+= "&end_date="+this.dateRange.endDate
      url += "&channel="+JSON.stringify([this.selectedChannel?.key])
      url += "&category="+JSON.stringify([this.selectedCategory?.key])
      url += "&warehouse="+JSON.stringify([this.selectedWarehouse?.key])
      this.$http
        .get(url)
        .then((response) => {
          this.viewRTOBreakupData = response.data.data.data;
          this.proccedRTOBreakupStackChartData = this.processStackChart(this.viewRTOBreakupData.monthly_data,'Customer Returns (RTV) Breakup by Channel');
          this.proccesRTOBreakupSemiPieChartData = this.processPieChart(this.viewRTOBreakupData.rto_sales_pie_chart_data,'RTV Sales by Channel',50);
          this.proccesRTOBreakupPieChartData = this.processPieChart(this.viewRTOBreakupData.category_pie_chart_data,'RTO Sales by category',0)
          this.rtoLoader = false;
        })
        .catch((error) => {
          this.rtoLoader = false;
          console.error("Error fetching table data:", error);
        });
    },

    getCODPrepaidData(){
      this.proccedPrepaidCODPieByChannelData = ''
      this.proccedPrepaidCODPieByCategoryData = ''

      const url = "/api/unicommerce/cod_prepaid/breakup"
     
      const payload = {
        start_date :  this.dateRange.startDate,
        end_date : this.dateRange.endDate,
        "channel": [this.selectedChannel?.key],
        category: [this.selectedCategory.key],
        warehouse: [this.selectedWarehouse?.key]

      }
      this.$http.post(url,payload).then(response=>{
          this.viewCODPrepaidData = response.data.data.data;
          this.proccedPrepaidCODPieByChannelData = this.processPieInnerChartData(this.viewCODPrepaidData.channel_wise_pie_chart);
          this.proccedPrepaidCODPieByCategoryData = this.processPieInnerChartData(this.viewCODPrepaidData.category_wise_pie_chart);
      })
    },  

    getCancelledCODPrepaidData(){
      const url = "/api/unicommerce/cancelled_cod_prepaid/breakup"
      const payload = {
        start_date :  this.dateRange.startDate,
        end_date : this.dateRange.endDate,
        "channel": [this.selectedChannel?.key],
        category: [this.selectedCategory.key],
        warehouse: [this.selectedWarehouse?.key]


      }
      this.$http.post(url,payload).then(response=>{
        this.viewCancelledCODPrepaidData = response.data.data.data;
        this.proccedCancelledPrepaidCODPieByChannelData = this.processPieInnerChartData(this.viewCancelledCODPrepaidData.channel_wise_pie_chart);
        this.proccedCategoryPrepaidCODPieByCategoryData = this.processPieInnerChartData(this.viewCancelledCODPrepaidData.category_wise_pie_chart);
      })
    },  

    getDemographicData(){
      const url = "/api/unicommerce/demographics/"
      this.demographicsDropdownData = [];
      this.proccedIndiaMapData = []
      this.viewDemographicData = ''
      this.demographicLoader = true;
      const payload = {
        start_date :  this.dateRange.startDate,
        end_date : this.dateRange.endDate,
        "channel": [this.selectedChannel?.key],
        category: [this.selectedCategory.key],
        warehouse: [this.selectedWarehouse?.key]


      }
      this.$http.post(url,payload).then(response=>{
        this.viewDemographicData = response.data.data
        this.demographicLoader = false;
        Object.keys(this.viewDemographicData?.map_data[0]).forEach((data)=>{
          if(data!='state_code' && data!='state_name'){
            this.demographicsDropdownData.push({key:data,label:data.replaceAll("_"," ").toLowerCase().split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")})
          }
        });
        this.selectedIndiaMapData = this.demographicsDropdownData[0]
        this.processIndiaMapData();
        this.$nextTick(() => {
              this.processTable("#demographicsDataTable");
          })
      }).catch(error=>{
        this.demographicLoader = false;
        console.error("Error fetching table data:", error);
      })
    },

    getMetricData(){
      this.summaryMetricData = ''
      this.metricLoader = true;
      const payload = {
        start_date:this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        channel: this.selectedChannel.key,
        category : this.selectedCategory.key,
        warehouse: this.selectedWarehouse.key
      }
      let url = "/api/unicommerce/business-summary/?start_date="
      +this.dateRange.startDate
      url+= "&end_date="+this.dateRange.endDate
      url += "&channel="+JSON.stringify([this.selectedChannel?.key])
      url += "&category="+JSON.stringify([this.selectedCategory?.key])
      url += "&warehouse="+JSON.stringify([this.selectedWarehouse?.key])
      this.$http
        .get(url)
        .then((response) => {
          this.metricLoader = false;
          this.summaryMetricData = response.data.data;
        })
        .catch((error) => {
          this.metricLoader = false;
          console.error("Error fetching table data:", error);
        });
    },

    getOrderBreakDownTableData(){
      this.summaryTableLoader = true;
      this.viewOrderBreakdownTabelData =  ''
      if ($.fn.DataTable.isDataTable('#summaryDataTable')) {
          $('#summaryDataTable').DataTable().destroy();
      }
      const url = "/api/unicommerce/orders_table/";
      const payload = {
        start_date:this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        level: this.activeTab,
        "channel": [this.selectedChannel?.key],
        category: [this.selectedCategory.key],
        warehouse: [this.selectedWarehouse?.key]
      };
      this.$http.post(url, payload).then((response) => {
          this.viewOrderBreakdownTabelData = response.data.data;
          this.summaryTableLoader = false
          this.$nextTick(() => {
              this.processOrderTable("#summaryDataTable");
          })
        })
        .catch((error) => {
          this.summaryTableLoader = false
          console.error("Error fetching table data:", error);
        });
    },

    exportOrdersBreakupData(tab) {
      if (tab === 'All') {
        this.isAllDownload = true;
      } else {
        this.isTabWiseExporting= true;
      }
      const url = "/api/unicommerce/orders_table/";
      const payload = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        level: tab, 
        export: true,
        "channel": [this.selectedChannel?.key],
        category: [this.selectedCategory.key],
        warehouse: [this.selectedWarehouse?.key]
      };
      this.$http.post(url, payload)
        .then((response) => {
          window.location = response.data.data?.file_url;
          this.isTabWiseExporting= false;
          this.isAllDownload = false;          
          
        })
        .catch((error) => {
          this.isTabWiseExporting= false;
          this.isAllDownload = false;          
          console.error("Error exporting data:", error);
        });
    },
    processNetSalesGraph(){
      const barChartMapper = ['total_sales','cancelled_units'];
      const yAxisData = ['cancelled_units'];
      const colorMapper = {"total_sales":'#065559',"cancelled_sales_amount":"#FCB117", "cancelled_units":"#FF4E4E","net_sales_amount":"#899EFC","monthly_avg_selling_price":"#EDB6AF"};
      const tempKey = Object.keys(this.viewNetSalesData.monthly_data[0]).filter(data=>data!='month')
      let data = {
        xAxis:[],
        seriesData: tempKey.map((data)=>{
          return {
            name:data.replaceAll("_"," ").toLowerCase().split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" "),
            key:data,
            disableYLabel:false,
            color: colorMapper[data],
            yAxis:  yAxisData.includes(data)?0:1,
            type: barChartMapper.includes(data)?'column':'line',
            marker: {
                enabled: true,
                lineWidth: 2,
                fillColor: "white",
                lineColor:  colorMapper[data],
                radius: 5,
            },
            data:[]
          }
        })
      }
      // graph data
      this.viewNetSalesData?.monthly_data.forEach(obj=>{
        data.xAxis.push(moment(obj.month).format("MMM-YYYYY"));
        data.seriesData.forEach((series,idx)=>{
          data.seriesData[idx].data.push(obj[series.key])
        })

      })
      this.proccedNetSalesGraphData = data
      // piechart data
      this.proccedNetSalesPieChartData = this.processPieChart(this.viewNetSalesData.pie_chart_data,'Net Sales Overview',0)
    },

    processPieChart(data,name,innerSize){
      const colorCodes= ["#92CED6","#EBBB69","#BACDF8","#FF4E4E","#ABE6E9","#99B9FF","#BACDF8","#92CED6","#ECF3FD"]
      return [{
        name: name.replaceAll("_"," "),
        innerSize: innerSize+"%",
        data: Object.keys(data).map((key,idx)=>{return {name:key.replaceAll("_"," "), color:colorCodes[idx], y:data[key]}})
      }]
    },

    processPieInnerChartData(data){
      const apiData= data;
      const name = '';
      // console.log(apiData)
      const colorCodes= ["#92CED6","#EBBB69","#BACDF8","#FF4E4E","#ABE6E9","#99B9FF","#BACDF8"]
      const seriesData= [{
        name: 'inner',
        innerSize: '50%',
        legend: false,
        data: apiData.map((data,idx)=>{
          return {name:data.label, color:colorCodes[idx], y:data.overall}
        }),
        size: '45%',
        showInLegend: true,
        dataLabels: {
            enabled: false,
            style: {
                color: '#A1A1A1',
                textOutline: 'none'
            },
            connectorColor: '#A1A1A1'
        }
        }, {
            name: 'outer',
            legend: false,
            showInLegend: false,
            data: this.getInnterPieData(apiData,colorCodes),
            size: '80%',
            innerSize: '60%',
            dataLabels: {
                format: '<p style="color:black">{point.name}</p>' ,
                style: {
                    color: '#A1A1A1',
                    textOutline: 'none'
                },
            connectorColor: '#A1A1A1'
            },
            id: 'versions'
        }]
        return seriesData;
    },
    getInnterPieData(apiData,colorCodes){
      const temp = [];
      apiData.forEach((data,idx)=>{
        temp.push({name:'COD', color:Highcharts.color(colorCodes[idx]).brighten(0).get() ,brightness:0, legent:false, y:data.cod},
          {name:'Prepaid',color:Highcharts.color(colorCodes[idx]).brighten(-0.18).get() , legend:false, y:data.prepaid})
        
      })
      return temp;
    },
    processStackChart(data,name){
      const tempKey = Object.keys(data[0]).filter(datakey=>datakey!='month')
      let temp = {
        categories: data.map(month=>moment(month.month).format("MMM,YYYY")),
        seriesData: [],
      }
      let tempSeries={name:'',data:[]}
      tempKey.forEach(key=>{
         tempSeries = {name:'',data:[]}
         data.forEach(data=>{
          tempSeries.name = key,
          tempSeries.data.push(data[key])
         })
         temp.seriesData.push(tempSeries)
      })
      return temp;
    },

    processIndiaMapData() {
      this.proccedIndiaMapData = []
      const selectedDropdownData= this.selectedIndiaMapData.key
      for (let [key, stateName] of Object.entries(this.indiaStateMapper)) {
          let matchingState = this.viewDemographicData.map_data.find(stateData => stateData.state_name === stateName);
          if (matchingState) {
            this.proccedIndiaMapData.push([key, matchingState[selectedDropdownData]])
          }
          else { 
              this.proccedIndiaMapData.push([key, -105, "#f0f0f0"])
          }
      }
  },

   processOrderTable(id) {
          $(id).DataTable().destroy();
          $(id).DataTable({
            searching: true,
            info: true,
            ordering: true,
            order: [],
            fixedColumns: true,
            // scrollX: true,
            "pageLength": 100,
            columnDefs: [
              {
                targets: 0,
                className: "min-width-column",
              },
            ],
            // initComplete: function () {
            //   $(id).wrap(
            //     "<div style='overflow:auto; width:100%;position:relative;'></div>"
            //   );
            // },
            language: {
              search: "",
              searchPlaceholder: "Search...",
              paginate: {
                first: "",
                previous: "<",
                next: ">",
                last: "",
              },
              lengthMenu: "<h5>Show entries</h5> _MENU_",
            },
          });
          $(id + "_filter > label").append(
            `<div class='search_icon'><img src='/Icons_SVG/Search.svg' width='20' /></div>`
          );
      },
    
    processTable(id) {
          $(id).DataTable().destroy();
          $(id).DataTable({
            searching: true,
            info: true,
            ordering: true,
            order: [],
            columnDefs: [
              {
                targets: 0,
                className: "min-width-column",
              },
            ],
            initComplete: function () {
              $(id).wrap(
                "<div style='overflow:auto; width:100%;position:relative;'></div>"
              );
            },
            language: {
              search: "",
              searchPlaceholder: "Search...",
              paginate: {
                first: "",
                previous: "<",
                next: ">",
                last: "",
              },
              lengthMenu: "<h5>Show entries</h5> _MENU_",
            },
          });
          $(id + "_filter > label").append(
            `<div class='search_icon'><img src='/Icons_SVG/Search.svg' width='20' /></div>`
          );
      },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

.card {
  /* margin-bottom: 1rem !important; */
}
.exportButton {
  margin-left: 6px;
  /* height: 35px; */
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px;
  font-weight: 600;
  padding: 0px 25px;
  letter-spacing: 0.2px;
}
.tab-label {
    cursor: pointer;
    padding-bottom: 12px;
    transition: all 0.3s ease;
    font-size: 16px;
    font-weight: 500;
}

.tab-label.active {
    color: rgba(6, 85, 89, 1);
    border-bottom: 1px solid rgba(6, 85, 89, 1);
    font-weight: 600 !important;
}
.stepper-container {
  padding: 20px;
  font-family: sans-serif;
}
.steps {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.step {
  font-weight: 600;
  color: #999;
}
.step.active {
  color: #065559;
  font-weight: bold;
}
.step-circle.active {
  background-color: #065559;
  color: white;
  padding: 10px;
  border-radius: 50%;
}
.line {
  flex-grow: 1;
  height: 2px;
  background-color: #ccc;
  margin: 0 10px;
}
.input-box {
  width: 100%;
  padding: 10px;
  border: 1px solid #aeaeae;
  border-radius: 5px;
  margin-bottom: 16px;
}
.suggestions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.sku-pill {
  border: 1px solid #aeaeae;
  border-radius: 20px;
  padding: 6px 12px;
  background: white;
  cursor: pointer;
}
.button-group {
  text-align: right;
}
button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}
</style>
<style>
.summaryContainer table.dataTable th {
  background: rgb(227 228 228) !important;
}
table.dataTable thead tr>.dtfc-fixed-left, table.dataTable thead tr>.dtfc-fixed-right, table.dataTable tfoot tr>.dtfc-fixed-left, table.dataTable tfoot tr>.dtfc-fixed-right {
  background-color: #f2f4f4;
}
@media only screen and (max-width: 600px) {
.daterangepicker .drp-calendar
{
    display: none;
    max-width: 270px;
    width: 240px;
}
}

.vue-daterange-picker .daterangepicker div.ranges {
    min-width: 94px;
}

.daterangepicker.opensright[data-v-1ebd09d2]
{
    left: 0px;
    right: auto;
}


#werehouseDateRange .multiselect__tags {
  border: 1px solid #ccc !important;
  max-height: 20px !important;
}
#werehouseDateRange .reportrange-text {
  height: 34px !important;
  width: 180px !important;
}
#werehouseDateRange .reportrange-text span {
  font-size: 16px !important;
}
.borderBetweenTab {
    border-bottom: 1px solid rgba(213, 213, 213, 1) !important;
    margin-bottom: 15px !important;
}

</style>